/**
 * Created by zhouxin on 2019-06-06
 **/
'use strict';
import request from '../utils/request'
const getMenusUrl = '/api/getmenus';
const authUrl = '/api/auth';

export default {
  getMenus (data) {
    return request({
      url: getMenusUrl,
      method: 'post',
      data: data
    })
  },
  auth () {
    return request({
      url: authUrl,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js